import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { versions, sourceToVersion } from '../config/versions';
import { TextFeature } from '../types';
import AppFeatures from '../components/Views/AppFeatures';
import WorkHistory from '../components/Views/WorkHistory';
import Contact from '../components/Views/Contact';
import Hero from '../components/Views/Hero';
import MyStory from '../components/Views/MyStory';

const textFeatures: TextFeature[] = [
  {
    id: 'work-history',
    title: 'Work History',
    content: '' // Content is now handled by the WorkHistory component
  },
  {
    id: 'contact',
    title: 'Contact',
    content: '' // Content is now handled by the Contact component
  },
];

const Home: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sourceParam = searchParams.get('src');
  const version = sourceParam ? (sourceToVersion[sourceParam] || 'default') : 'default';
  const config = versions[version] || versions.default;

  // Populate features in the config
  config.textFeatures = textFeatures;

  return (
    <div className="min-h-screen mt-2 sm:mt-12 bg-white text-black">
      {/* Content Column */}
      <div className="w-full max-w-[43rem] py-8 px-4 mx-auto">
        {/* Hero Section with Image */}
        <section className="mb-16">
          <Hero heroSubtitle={config.heroSubtitle} />
          <MyStory aboutText={config.aboutText} />
        </section>

        {/* Featured Section */}
        <section className="mb-16">
          <div className="space-y-12">
            {/* Apps I've Built */}
            <AppFeatures />

            {/* Text Features */}
            {config.textFeatures.map((feature) => (
              <div key={feature.id}>
                <h3 className="text-lg font-light text-black mb-4">{feature.title}</h3>
                <div className={`rounded-lg ${feature.id === 'work-history' ? 'pl-0 pr-0' : 'pl-4 sm:pl-0'}`}>
                  {feature.id === 'work-history' ? (
                    <WorkHistory />
                  ) : feature.id === 'contact' ? (
                    <Contact />
                  ) : (
                    <p className="text-black text-left">
                      {feature.content}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;